<p-chip
    [label]="label()"
    [removable]="removable()"
    (onRemove)="remove.emit()" />
